



import { useContext } from "react"
import { GlobalContext } from "../GlobalContext"
import Modal from "./Modal"
import Button from "../formfields/Button"
import Spinner from "./Spinner"

type Props = {
}


function ReconnectModal({
}: Props) {

    const {
        connectionState
    } = useContext(GlobalContext)



    return <Modal zIndex={50}>
        <div className={`w-full flex flex-col gap-4 items-center`}>
            <Spinner size="large" alignment="left">
                <div className={`w-full`}>
                    <p className={`font-righteous text-lg text-brandblue`}>Connecting... </p>
                    <p>Current status: {connectionState}</p>
                </div>
            </Spinner>
        </div>
    </Modal>
}

export default ReconnectModal